import React, { lazy } from 'react';
import { Route } from 'react-router-dom';
import PrivateRoute from '@/components/auth/PrivateRoute';
import { MENU } from '@/constants/menuCodes';

const CustomerStatusPage = lazy(() => import('@/pages/customers/CustomerStatusPage'));
const CustomerListPage = lazy(() => import('@/pages/customers/CustomerListPage'));
const CustomerDetailPage = lazy(() => import('@/pages/customers/CustomerDetailPage'));
const CustomerEmployeeList = lazy(() => import('@/pages/customers/CustomerEmployeeList'));
const LeadOpportunityPage = lazy(() => import('@/pages/crm/LeadOpportunityPage'));
const CustomerDealPage = lazy(() => import('@/pages/sales/CustomerDealPage'));
const SalesActivityReportPage = lazy(() => import('@/pages/sales/SalesActivityReportPage'));

/** 고객관리 / 영업 모듈 라우트 */
const crmRoutes = [
  <Route
    key="customers-status"
    path="customers/status"
    element={<PrivateRoute menuCode={MENU.CRM_CUSTOMER_STATUS}><CustomerStatusPage /></PrivateRoute>}
  />,
  <Route
    key="customers-list"
    path="customers/list"
    element={<PrivateRoute menuCode={MENU.CRM_CUSTOMER}><CustomerListPage /></PrivateRoute>}
  />,
  <Route
    key="customers-detail"
    path="customers/detail/:id"
    element={<PrivateRoute menuCode={MENU.CRM_CUSTOMER}><CustomerDetailPage /></PrivateRoute>}
  />,
  <Route
    key="customers-employees"
    path="customers/employees"
    element={<PrivateRoute menuCode={MENU.CRM_CUSTOMER_EMPLOYEE}><CustomerEmployeeList /></PrivateRoute>}
  />,
  <Route
    key="crm-opportunities"
    path="crm/opportunities"
    element={<PrivateRoute menuCode={MENU.CRM_OPPORTUNITY}><LeadOpportunityPage /></PrivateRoute>}
  />,
  <Route
    key="sales-activities"
    path="sales/activities"
    element={<PrivateRoute menuCode={MENU.CRM_SALES_ACTIVITY}><CustomerDealPage /></PrivateRoute>}
  />,
  <Route
    key="sales-reports"
    path="sales/reports"
    element={<PrivateRoute menuCode={MENU.CRM_SALES_REPORT}><SalesActivityReportPage /></PrivateRoute>}
  />,
];

export default crmRoutes;
